module.exports = function(){ /* empty */ };


/*****************
 ** WEBPACK FOOTER
 ** ./~/core-js/library/modules/$.add-to-unscopables.js
 ** module id = 390
 ** module chunks = 0
 **/